import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const createHelpers = (width, height, css) => {
    // somehow sizes is ending up in markup, even if it is not a valid svg attribute
    // until we have a better solution, just render it empty, instead to '[Object object]'
    const sanitizeSizes = sizes =>
        Object.defineProperty(sizes, "toString", {
            value: () => "",
            enumerable: false
        });

    const getDimensions = (size, sizes) => {
        if (
            size &&
            typeof size.width === "number" &&
            typeof size.height === "number"
        ) {
            return size;
        }

        return size && sizes[size] ? sizes[size] : { width, height };
    };

    const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
        if (noStyles) {
            return "";
        }

        const dimensions = getDimensions(size, sizes);
        const fillRule =
            fillColor && fillColorRule
                ? `${fillColorRule}{ fill: ${fillColor}; }`
                : "";

        return css`
            width: ${dimensions.width}px;
            height: ${dimensions.height}px;
            ${fillRule}
        `;
    };

    const propsToCss = ({ size, sizes, fillColor, fillColorRule, noStyles }) =>
        getCss(size, sizes, fillColor, fillColorRule, noStyles);

    return {
        getCss,
        getDimensions,
        propsToCss,
        sanitizeSizes
    };
};

const width = "29";
const height = "34";
const viewBox = "0 0 29 34";

const { getDimensions, getCss, propsToCss, sanitizeSizes } = createHelpers(
    width,
    height,
    css
);

const sizes = sanitizeSizes({
    small: { width: 17, height: 17 },
    medium: { width: 24, height: 24 }
});

const Image = styled.svg`
    ${propsToCss}
`;

const children = (
    <Fragment>
        <defs key="key-0">
            <path
                id="s-2623582680-a"
                d="M25.762 20.93c-.11 1.386-.2 2.68-.292 3.957-.127 1.823-2.097 3.901-3.883 4.084a19.87 19.87 0 01-2.079.127c-.62 0-.875.256-.838.894.036.674 0 1.33.036 2.005.037.565-.164.857-.766.857-4.193 0-8.386 0-12.58-.018-.054 0-.11-.055-.255-.128-.055-.528-.182-1.13-.182-1.732 0-2.698.036-5.415 0-8.113 0-.31-.183-.73-.401-.912C2.115 19.91.71 17.23.292 14.221c-.401-3.008.2-5.98 2.005-8.587C3.92 3.282 6.071 1.586 8.751.71c4.14-1.33 8.059-.784 11.632 1.823 1.532 1.13 2.808 2.462 3.774 4.12.949 1.642 1.094 3.428 1.35 5.215.054.346.073.711.2 1.04.748 1.877 1.532 3.755 2.261 5.633.583 1.495.091 2.206-1.477 2.297a4.69 4.69 0 01-.73.091zm-3.686-5.345a1.37 1.37 0 100-2.74 1.37 1.37 0 000 2.74z"
            />
        </defs>
        <g
            fill="none"
            fillRule="evenodd"
            transform="translate(0 .5)"
            key="key-1"
        >
            <mask id="s-2623582680-b" fill="#fff">
                <use xlinkHref="#s-2623582680-a" />
            </mask>
            <g fill="#404040" mask="url(#s-2623582680-b)">
                <path d="M-13.933-11.733h55v55h-55z" />
            </g>
        </g>
    </Fragment>
);

const defaultProps = {
    children,
    viewBox,
    fillColor: null,
    fillColorRule: "&&& path, &&& use, &&& g",
    sizes,
    size: null
};

Image.propTypes /* remove-proptypes */ = {
    fillColor: PropTypes.string,
    fillColorRule: PropTypes.string,
    viewBox: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            height: PropTypes.number.isRequired,
            width: PropTypes.number.isRequired
        })
    ]),
    sizes: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
    })
};

export default Object.assign(Image, {
    getDimensions,
    getCss,
    defaultProps,
    displayName: "AvatarPlaceholder"
});
